import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { TextEllipsisStaticLine } from '../../../common/textEllipsis/TextEllipsisStaticLine'
import { Tooltip } from '../../../common/tooltip'
import { Cell } from './Cell'
import { convertDataTable, getLabelFromValue } from './helper'
import classes from './index.module.scss'
import { selectData } from './store/slice'

export const Table = ({ isDynamicReport }) => {
  const data = useSelector(selectData)

  const analyseLabel = getLabelFromValue(data?.analyseType)
  const versusLabel = getLabelFromValue(data?.versusType)

  const schema = convertDataTable(data)

  return (
    <div className={classes.table}>
      <div className="dFlex gap2 alignItemsStretch">
        <Element className={classes.leftLabel}>
          <Element
            className={classes.text}
            style={{ fontSize: 20, color: '#9C9C9C' }}
          >
            <Translate value={analyseLabel} />
          </Element>
        </Element>

        <div className="flex1 minW0">
          <Element
            className="fw500 pb1 textCenter"
            style={{ fontSize: 20, color: '#9C9C9C' }}
          >
            <Translate value={versusLabel} />
          </Element>

          <div className={classes.grid}>
            <div className={classes.left}>
              <div className={classes.p10}>&nbsp;</div>
              {schema.yTicks.map((item, index) => (
                <div key={index} className={classes.p10}>
                  {item.tooltip ? (
                    <Tooltip tooltipContent={item.tooltip} isI18n={false}>
                      {item.value}
                    </Tooltip>
                  ) : (
                    item.value
                  )}
                </div>
              ))}
            </div>

            <div className={classes.right}>
              <div className={classes.row}>
                {schema.xTicks.map((item, index) => (
                  <div
                    key={index}
                    className={`${classes.py10} flex1 minW0 textCenter`}
                  >
                    {item.tooltip ? (
                      <Tooltip tooltipContent={item.tooltip} isI18n={false}>
                        <TextEllipsisStaticLine
                          text={item.value}
                          isI18n={false}
                          tooltipMaxWidthByContent
                          lineClamp={1}
                        />
                      </Tooltip>
                    ) : (
                      <TextEllipsisStaticLine
                        text={item.value}
                        isI18n={false}
                        tooltipMaxWidthByContent
                        lineClamp={1}
                      />
                    )}
                  </div>
                ))}
              </div>
              {schema.data.map((row, rowIndex) => (
                <div key={rowIndex} className={classes.row}>
                  {row.map((item, colIndex) => {
                    return (
                      <Cell
                        key={colIndex}
                        item={item}
                        schema={schema}
                        rowIndex={rowIndex}
                        colIndex={colIndex}
                        isDynamicReport={isDynamicReport}
                      />
                    )
                  })}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
